import React from 'react';
import { ProjectStatus } from '../DTO/ProjectStatus';

// Status colors per DESIGN.md: completed = forest, in progress = gentian, everything else = muted.
const STATUS: Record<ProjectStatus, { label: string; color: string }> = {
    COMPLETED:   { label: 'Completed',   color: 'text-forest' },
    IN_PROGRESS: { label: 'In progress', color: 'text-gentian' },
    PLANNED:     { label: 'Planned',     color: 'text-muted' },
    ON_HOLD:     { label: 'On hold',     color: 'text-muted' },
    CANCELLED:   { label: 'Cancelled',   color: 'text-muted' },
};

export const StatusLabel: React.FC<{ status: ProjectStatus; className?: string }> = ({ status, className = '' }) => {
    const s = STATUS[status] ?? { label: status, color: 'text-muted' };
    return (
        <span className={`inline-flex items-center gap-1.5 font-label text-sm font-medium ${s.color} ${className}`}>
            <span className="w-2 h-2 rounded-full bg-current" aria-hidden />
            {s.label}
        </span>
    );
};
